import React from 'react'
import { useThemeStyling } from 'hooks/useThemeStyling/useThemeStyling';

interface ILogoProps {
    className?: string
    alt: string
    src: string
}

/**
 * Standard logo for now
 */
const Logo = ({ className, alt, src }: ILogoProps) => {
    const { clientTheme } = useThemeStyling()
    
    return (
        <img
            src={src}
            className={`app-logo ${className}`}
            alt={alt}
            style={{
                maxWidth: clientTheme.topBar.brandLogo.maxWidth,
                paddingTop: clientTheme.topBar.brandLogo.paddingTop,
            }}
        />
    )
}

export default Logo
